<!--
* 组件名 : 上下章入口组件
* 开发者 : JY
*
* 参数:  null
*
* 事件:  null
* 
*
-->
<template>
  <div :class="['chapter-switch-entry', bgColor]" ref="chapterSwitchEntry">
    <div
      :class="[
        'switch-content d-flex justify-content-center',
        entryArr.length < 2 ? 'one' : '',
      ]"
    >
      <div
        class="entry-content d-flex flex-wrap flex-column justify-content-between"
        v-for="(item, i) in entryArr"
        :key="i"
        @click="click_route_link(item.path)"
      >
        <div class="entry-head">
          <div class="chapter-pisode">
            <span v-html="item.episode"></span>
          </div>
          <h4 class="connect-title title1" v-if="item.children">
            {{ item.title | remove_num("、") }}
          </h4>
          <h4 class="connect-title title1" v-else>
            {{ item.title }}
          </h4>
        </div>
        <div class="entry-body d-flex flex-column align-items-center">
          <div class="chapter-images">
            <div class="image-box">
              <img :src="item.poster" :alt="item.title" />
            </div>
          </div>
          <button
            class="v-btn page-arrow prev"
            v-if="i < 1 && entryArr.length > 1"
          >
            <v-icon>west</v-icon><span>{{ $TL.prevChapter }}</span>
          </button>
          <button class="v-btn page-arrow next" v-else>
            <span>{{ $TL.nextChapter }}</span>
            <v-icon>east</v-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { i18n } from "@/utils/util";
import { hackRoutes } from "@/mixin/parents-attach-first-child-config";

export default {
  name: "v-chatper-entry",
  props: {
    bgColor: {
      type: String,
      default: "cyan",
    },
  },
  data() {
    return {
      entryArr: [],
    };
  },
  components: {},
  filters: {
    remove_num(value, segmentation) {
      let arr = value.trim().split(segmentation);

      if (arr.length > 1) {
        return arr.slice(1).join(segmentation);
      } else {
        return arr[0];
      }
    },
  },
  created() {
    this.find_chatper_entry();
  },
  mounted() {
    this.ie11_comp();
  },
  methods: {
    /**
     * 查找上下章入口
     */
    find_chatper_entry() {
      this.$AsideRoute.map((item, i) => {
        // item.children = [];
        item.poster = i18n(`images/home/thumb${item.path}.jpg`);

        if (item.slug === this.$route.name) {
          if (i <= 1) {
            this.entryArr.push(this.$AsideRoute[i + 1]);
          } else if (i > 1 && i < this.$AsideRoute.length - 1) {
            //  判断是否是父子合并的章节
            this.entryArr.push(
              this.$AsideRoute[i - 1],
              this.$AsideRoute[
                i + (Object.keys(hackRoutes).includes(this.$route.name) ? 2 : 1)
              ]
            );
          } else if (i >= this.$AsideRoute.length - 1) {
            this.entryArr.push(this.$AsideRoute[i - 1]);
          }
        }
      });
    },
    /**
     * 路由点击跳转
     */
    click_route_link(path) {
      this.$router.push(path);
    },
    /**
     *  IE 11 兼容
     */
    ie11_comp() {
      this.$P.isIE11 &&
        $(this.$refs.chapterSwitchEntry)
          .closest(".v-page")
          .css({ overflow: "hidden" });
    },
  },
};
</script>

<style lang="scss">
.chapter-switch-entry {
  padding: 48px 0;
  margin-top: 140px;

  &.cyan {
    background-color: rgba(#96c4d6, 0.34);
  }

  &.earth {
    background-color: rgba(#d6bda3, 0.34);
  }

  &.margin0 {
    margin-top: 0;
  }

  span,
  h4 {
    transform: translateZ(0);
  }

  .switch-content {
    margin: auto;
    position: relative;

    &:nth-of-type(1) {
      &::before {
        content: "";
        display: block;
        height: 308px;
        width: 1px;
        background-color: rgba(#707070, 0.16);
        position: absolute;
        right: 0;
        left: 0;
        bottom: 54px;
        margin: auto;
      }
    }

    &.one {
      &::before {
        display: none;
      }

      .entry-content {
        margin-right: 0;
      }
    }
  }

  .entry-head {
    text-align: center;
  }

  .entry-content {
    box-sizing: inherit;
    cursor: pointer;
    width: 630px;

    &:hover {
      .image-box img {
        transform: scale(1.03);
      }

      .page-arrow {
        &.prev i {
          transform: translateX(-2px);
        }

        &.next i {
          transform: translateX(2px);
        }
      }
    }

    &:nth-of-type(1) {
      margin-right: 180px;
    }

    &:nth-of-type(2) {
      margin-left: 180px;
      &::before {
        content: "";
      }
    }
  }

  .entry-body {
    margin-top: 30px;
    width: 100%;

    .chapter-images {
      margin-bottom: 30px;
      max-width: 468px;
      width: 78%;
      border-radius: 8px;
      overflow: hidden;
      -webkit-backface-visibility: hidden;
      -moz-backface-visibility: hidden;
      -webkit-transform: translate3d(0, 0, 0);
      -moz-transform: translate3d(0, 0, 0);

      .image-box {
        width: 100%;
        position: relative;
        padding-top: 62.82%;
      }

      img {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        max-width: 100%;
        transition: transform 0.5s ease;
        object-position: center;
        object-fit: cover;
      }
    }

    .page-arrow {
      span,
      i {
        color: $color-chapter-title;
      }

      i {
        font-size: 22px;
      }
    }
  }

  .chapter-pisode {
    margin-bottom: 16px;

    span {
      font-size: 18px;

      &:nth-of-type(2) {
        padding-left: 20px;
      }
    }
  }

  @media (max-width: $lx-max) {
    .entry-content {
      width: 470px;

      &:nth-of-type(1) {
        margin-right: 108px;
      }

      &:nth-of-type(2) {
        margin-left: 108px;
      }

      .chapter-pisode {
        span {
          font-size: 14px;
        }
      }
    }
  }

  @media (max-width: $lx-min) {
    .entry-content {
      width: 590px;

      &:nth-of-type(1) {
        margin-right: 80px;
      }

      &:nth-of-type(2) {
        margin-left: 80px;
      }
    }
  }
}

body.latin {
  .chapter-switch-entry {
    .chapter-pisode span {
      font-size: 14px;
    }
  }
}
</style>
